import { IPublicClientApplication } from '@azure/msal-browser';
import { AcceptItem } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  getCurrentUser,
  getCurrentUserAcceptItems,
  getCurrentUserCompanyInformation,
  getCurrentUserPartnerIds,
  submitAcceptedItem,
  updateCurrentUser,
} from './index';

export const createUsersApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getCurrentUserAcceptItems: (instance: IPublicClientApplication, userId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCurrentUserAcceptItems(fetchContext, userId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCurrentUserAcceptItems', isInFlight);
    },
  ),
  submitAcceptedItem: (instance: IPublicClientApplication, userId: number, acceptItem: AcceptItem) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => submitAcceptedItem(fetchContext, userId, acceptItem, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('submitAcceptedItem', isInFlight);
    },
  ),
  getCurrentUser: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCurrentUser(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCurrentUser', isInFlight);
    },
  ),
  updateCurrentUser: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateCurrentUser(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateCurrentUser', isInFlight);
    },
  ),
  getCurrentUserCompanyInformation: (instance: IPublicClientApplication, accountId: string) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCurrentUserCompanyInformation(fetchContext, accountId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCurrentUserCompanyInformation', isInFlight);
    },
  ),
  getCurrentUserPartnerIds: (instance: IPublicClientApplication, userId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCurrentUserPartnerIds(fetchContext, userId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCurrentUserPartnerIds', isInFlight);
    },
  ),
});
